import { z } from "zod";

import { machineBaseSchema } from "../machine-base";
import { machineTypeSchema } from "../machine-type";

export const impackMachineSchema = machineBaseSchema.extend({
	machineType: z.literal(machineTypeSchema.enum.Impack),
	status: z.string().transform(() => "Disabled" as const),
});
export type ImpackMachine = z.infer<typeof impackMachineSchema>;

export const prepareImpackMachineData = (data: unknown): unknown => {
	if (typeof data !== "object" || data === null) {
		return data;
	}

	const input = data as Record<string, unknown>;

	// Impack is a non-cloud reference machine hardcode the known defaults.
	const iotDevice = {
		deviceId: input.iotDeviceId ?? "",
		deviceName: input.iotEdgeDeviceId ?? "",

		hubName: input.iotHubName ?? "",
		moduleId: input.iotEdgeModuleId ?? "",
		moduleVersion: input.edgeModuleVersion ?? "",
		lastProofOfLife: input.lastProofOfLifeTimeStamp,
	};

	const stopReason = { stopCode: -1, message: "Offline", arguments: [] as number[], isError: false };
	const activeWarnings: { message: string; code: number; arguments: number[] }[] = [];

	return {
		id: input.id ?? "",
		tenantId: input.tenantId ?? "",
		assetId: input.assetId ?? "",
		alias: input.alias ?? "",
		description: input.description ?? "",
		plcVersion: input.plcVersion ?? "",
		machineType: "Impack",
		status: "Disabled",
		productionStatus: input.productionStatus ?? "Unknown",
		stopReason,
		activeWarnings,
		workstations: [],
		iotDevice,
		ipOrDnsName: input.ipOrDnsName ?? "",
		port: input.port ?? 80,
		securePrintConfiguration: { delayLabelRetrieval: false },
	};
};
